module.exports = __webpack_public_path__ + "static/media/img_adm_module1.cf43d20d.png";